import React, { useEffect, useState } from 'react';
import NoticeForm from '../../components/Notices/NoticeForm';
import { getNoticeById, updateNotice, sendNotice } from '../../api/services/noticeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { unitApi } from '../../api/services/unitApi';
import { Bell, Edit } from 'lucide-react';
import toast from 'react-hot-toast';
import SettingsHeader from '../../ui/SettingsHeader';

const NoticeEdit = () => {
  const [loading, setLoading] = useState(false);
  const [initial, setInitial] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [classOptions, setClassOptions] = useState([]);

  useEffect(() => {
    async function fetchClasses() {
      try {
        const res = await unitApi.getAllUnits();
        const opts = (res.data || res || []).map(u => ({
          value: u.id || u._id,
          label: u.unitName || u.name,
          sections: u.sections || []
        }));
        setClassOptions(opts);
      } catch {
        setClassOptions([]);
      }
    }
    fetchClasses();
  }, []);

  useEffect(() => {
    getNoticeById(id).then(res => {
      const noticeData = res.success && res.data ? res.data : res || {};
      
      // Check if notice is already sent
      if (noticeData.status === 'sent') {
        toast.error("Cannot edit a notice that has already been sent");
        navigate(`/notices/${id}`);
        return;
      }
      
      setInitial(noticeData);
    }).catch(err => {
      toast.error("Failed to load notice");
      navigate('/notices');
    });
  }, [id, navigate]);

  const handleSubmit = async (data, action) => {
    setLoading(true);
    try {
      await updateNotice(id, data);
      
      if (action === 'sent') {
        await sendNotice(id);
        toast.success("Notice Updated and Sent!");
      } else {
        toast.success(action === 'draft' ? "Saved as Draft" : "Notice Updated");
      }
      navigate('/notices');
    } catch (error) {
      toast.error("Failed to update notice");
    } finally {
      setLoading(false);
    }
  };

  if (!initial || classOptions.length === 0) return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="w-8 h-8 border-2 border-indigo-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );

  return (
    <div className="animate-in fade-in duration-500 pb-10">
      <SettingsHeader
        title="Compose Notice"
        description="Create and distribute official communications to students and parents."
        showBack={true}
        onBack={() => navigate('/notices')}
        icon={Bell}
      />

      <div className="max-w-7xl mx-auto px-4 mt-6">
        <NoticeForm
          initial={initial}
          onSubmit={handleSubmit}
          classOptions={classOptions}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default NoticeEdit;
